import React, { useState , useEffect } from "react";
import { USERS_ICON, LOADING_SPIN_SMALL } from "../../assets/constants/Icons";
import { TYPE_SUCCESS, TYPE_INFO, INTERVAL, emailPattern, PHONE_NUMBER_PATTERN } from "assets/constants/Constants";
import ShowToast from 'components/ShowToast';
import { useLocation ,useHistory } from "react-router-dom";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import "./candidate.css";
import { calculateAgeFromDate, fetchMetadata, sanitizeAnnualIncome } from 'lib/utils';
import { getPartnerList, createCandidateCall, updateCandidateCall, checkEmailPresent, checkAadharPresent, getS3PresignedUrl, uploadDocumentBucket, downloadDocumentBucket } from "lib/axiosUtils";

const MIN_CANDIDATE_AGE = 18;
const MIN_CANDIDATE_AGE_ERROR = "Candidate must be 18 or older";

const CreateCandidate = (props) => {
    const location = useLocation();
    const history = useHistory();
    const [candidateID] = useState(location.state ? (location.state.candidateId ? location.state.candidateId : null): null);
    const [firstName, setFirstName] = useState(location.state ? (location.state.firstName ? location.state.firstName : "") : "");
    const [lastName, setLastName] = useState(location.state ? (location.state.lastName ? location.state.lastName : ""): "");
    const [fatherName, setFatherName] = useState(location.state ? (location.state.fatherName ? location.state.fatherName : ""):"");
    const [dobDate, setdobDate] = useState(location.state ? (location.state.dobDate ? new Date(location.state.dobDate) : null): "");
    const [ageNumber, setAgeNumber] = useState(location.state ? (location.state.ageNumber ? location.state.ageNumber : "") : "");
    const [mobileNumber, setMobileNumber] = useState(location.state ? (location.state.mobileNumber ? location.state.mobileNumber : ""): "");
    const [qualificationsName, setQualificationsName] = useState(location.state ? (location.state.qualificationsName ? location.state.qualificationsName : ""): "");
    const [adharNo, setAdharNo] = useState(location.state ? (location.state.adharNo ? location.state.adharNo : ""): "");
    const [email, setEmail] = useState(location.state ? (location.state.email ? location.state.email : ""): "");
    const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
    const [gender, setGender] = useState(location.state ? (location.state.gender ? location.state.gender : ""): "");
    const [error, setError] = useState({});
    const [selectedGenderOption, setGenderSelectedOption] = useState(location.state ? (location.state.gender ? { value: location.state.gender, label: location.state.gender } : ""): "");
    const [qualificationsListComponent, setQualificationsListComponent] = useState([]);
    // const [departmentSelected, setDepartmentSelected] = useState(location.state ? (location.state.departmentSelected ? {label:location.state.departmentSelected,value:location.state.departmentSelected} : null) : null);
    // const [departmentListComponent, setDepartmentListComponent] = useState("<option> Select Department </option>");
    // const [employerListComponent, setEmployerListComponent] = useState("<option> Select Employer unit </option>");
    const [partnerListComponent, setPartnerListComponent] = useState("<option> Select Partner </option>");
    // const [employerUnit, setEmployerUnit] = useState(location.state ? (location.state.employerUnit ? {label:location.state.employerUnit,value:location.state.employerId} : null) : null);
    const [trainingPartner, setTrainingPartner] = useState(location.state ? (location.state.trainingPartner ? {label:location.state.trainingPartner,value:location.state.partnerId} : null) : null);
    const [stateComponent, setStateComponent] = useState("<option> Select State </option>");
    const [cityComponent, setCityComponent] = useState("<option> Select City </option>");
    const [metaData,setMetaData] = useState(JSON.parse(localStorage.getItem("metadata")) ? JSON.parse(localStorage.getItem("metadata")) : []);
    const [programId] = useState(location.state ? (location.state.programId ? location.state.programId : "") : "");
    // const [batch, setBatch] = useState(() => {
    //     const rawBatch = location.state?.batch;
    //     const parsedBatch = Number(rawBatch);
    //     return Number.isFinite(parsedBatch) ? parsedBatch : null;
    // });
    const userDetails = JSON.parse(localStorage.getItem("userData"));
    const userRole = userDetails?.user_role || userDetails?.role || "";
    const loggedPartnerId = userDetails?.partner_id || userDetails?.selectedTrainingPartner || null;
    const [primaryOccupation, setPrimaryOccupation] = useState(location.state ? (location.state.primaryOccupation ? location.state.primaryOccupation : "") : "");
    const [annualIncome, setAnnualIncome] = useState(location.state ? (location.state.annualIncome ? location.state.annualIncome : null) : null);
    const [engagementType, setEngagementType] = useState(location.state ? (location.state.engagementType ? { label: location.state.engagementType, value: location.state.engagementType } : null) : null);
    const [engagementTypeOptions] = useState([
        { label: "CSR", value: "CSR" },
        { label: "RTD", value: "RTD" }
    ]);
    const [passingYear, setPassingYear] = useState(location.state ? (location.state.passingYear ? location.state.passingYear : "") : "");
    const [loading, setLoading] = useState(false);
    const [documentSectionData, setDocumentSectionData] = useState({
        aadharUpload: location.state?.documents?.aadhar || "",
        panUpload: location.state?.documents?.pan || "",
        qualificationUpload: location.state?.documents?.qualification || ""
    });
    const isPartnerLogin = userRole === "training partner";


    const handleAnnualIncomeChange = (event) => {
        const nextValue = event.target.value;
        const formattedValue = nextValue
            .replace(/[^\d,Rs₹.\s-]/gi, "")
            .replace(/(?!^)-/g, "")
            .trim();
        setAnnualIncome(formattedValue);
    };
    
    const genderOptions = [
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' },
        { value: 'other', label: 'Other' }
    ];

    useEffect(() =>{
        const fetchData = async() => {
            if(metaData && metaData.length === 0){
                const metaResult = await fetchMetadata();
                setMetaData(metaResult)
            }
        }
        fetchData();
    },[metaData])

    useEffect(() => {
        const setQualificationsComponentList = () => {
            const qualificationsMetaData = metaData[0].meta_data.qualifications;
            let listQualifications = qualificationsMetaData.map((item) => {
                if (props.location.state) {
                    if (qualificationsName === item.education_name) {
                        setQualificationsName({ label: item.education_name, value: item.education_name });
                    }
                }
                return ({ label: item.education_name, value: item.education_name })
            })
            setQualificationsListComponent(listQualifications);
        }
        setQualificationsComponentList();
        // setDepartmentComponentList();
        // eslint-disable-next-line
    }, [qualificationsName,(props.location.state),metaData]);

    // const setUnitComponent = (list) => {
    //     let listComponent =  list.map((item) => {
    //         return ({label: item.unit_name, value: item._id});
    //     })
    //     // setEmployerListComponent(listComponent);
    // }


    useEffect(() =>{
        let isMounted = true;

        // const fetchEmployerList = async () => {
        //     try {
        //         const data = await getEmployerList();
        //         // if (!isMounted) return;
        //         // setUnitComponent(data.data.result);
        //     }
        //     catch (error) {
        //         console.log("error while fetching data", error);
        //     }
        // }

        const fetchPartnerList = async () => {
            try {
                const response = await getPartnerList();
                if (!isMounted) return;
                const listComponent = response.data.result.map((item) => ({
                    label: item.training_partner,
                    value: item._id
                }));
                setPartnerListComponent(listComponent);

                if (isPartnerLogin && loggedPartnerId) {
                    const loggedPartner = response.data.result.find((item) => item._id === loggedPartnerId);
                    if (loggedPartner && !location.state?.trainingPartner && isMounted) {
                        setTrainingPartner({
                            label: loggedPartner.training_partner,
                            value: loggedPartner._id
                        });
                    }
                }
            }
            catch (error) {
                console.log("Error Occurred while fetching training partner list", error);
            }
        }

        // fetchEmployerList();
        fetchPartnerList();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line
    },[isPartnerLogin, loggedPartnerId])

    useEffect(() => {
        setStateListComponent();
        setCityListComponent();
        // eslint-disable-next-line
    },[props]);

    const setStateListComponent = () =>{ 
        const list  = metaData[0].meta_data.states.map((item) => {
            if(props.location.state && props.location.state.state){
                if(item.state_name.toLowerCase() === props.location.state.state.toLowerCase() ){
                    setState({label: item.state_name, value: item.state_id });
                }
            }
            return ({label: item.state_name, value: item.state_id})
        });
        setStateComponent(list);
    }

    const setCityListComponent = () => {
        const list =  metaData[0].meta_data.cities.map((item) => {
            if(props.location.state && props.location.state.city){
                if(item.city_name.toLowerCase() === props.location.state.city.toLowerCase() ){
                    setCity({label: item.city_name, value: item.city_id });
                }
            }
            return ({label: item.city_name, value: item.city_id});
        })
        setCityComponent(list);
    } 

    // const setDepartmentComponentList = () => {
    //     const department =  metaData[0].meta_data.department;
    //     const list = department.map((item) => {
    //         return ({ label: item, value: item });
    //     })
    //     setDepartmentListComponent(list);
    // }

    const adharChangeHandler = (event) => {
        if(!isNaN(event.target.value)){
            setAdharNo(event.target.value);
        }
    }
    
    const mobileNumberHandler = (event) => {
        if(!isNaN(event.target.value)){
            setMobileNumber(event.target.value);
        }
    }

    const createCandidateHandler = async (event) => {
        event.preventDefault();
        if (loading) return;
        if (isFormValid()) {
            setLoading(true);
            try {
                const isEmailPresent = await checkEmailPresent({}, {}, email ? email : null, mobileNumber ?  mobileNumber : null);
                const isAadharPresent = await checkAadharPresent({}, {}, adharNo);

                if ((isEmailPresent.data.result.emailExists || isEmailPresent.data.result.mobileExists || isAadharPresent.data.result.length > 0) && !candidateID) {
                    let error = {};
                    if (isEmailPresent.data.result.emailExists) {
                        error.emailIdError = "Entered Email ID is associated with another Candidate";
                    }

                    if (isEmailPresent.data.result.mobileExists) {
                        error.MobileNoError = "Entered Mobile is associated with another Candidate";
                    }

                    if (isAadharPresent.data.result.length > 0) {
                        error.aadharNumberError = "Entered Aadhar number is associated with another Candidate";
                    }
                    setError(error);
                } else {
                    setError({});
                    try {
                        const uploadedDocumentUrls = {
                            aadhar: documentSectionData.aadharUpload ? await uploadDocumentFileToS3("Aadhar Card", documentSectionData.aadharUpload) : "",
                            pan: documentSectionData.panUpload ? await uploadDocumentFileToS3("PAN Card", documentSectionData.panUpload) : "",
                            qualification: documentSectionData.qualificationUpload ? await uploadDocumentFileToS3("Qualification Certificate", documentSectionData.qualificationUpload) : ""
                        };

                        const requestData = {
                            firstName: firstName,
                            lastName: lastName,
                            fatherName: fatherName,
                            dobDate: dobDate,
                            ageNumber: ageNumber,
                            mobileNumber: mobileNumber,
                            adhaarNo: adharNo,
                            qualification: qualificationsName.label,
                            email: email,
                            gender: gender,
                            state: state ? state.label : "",
                            city: city ? city.label : "",
                            // departmentSelected: departmentSelected ? departmentSelected.label : "",
                            // employerUnit: employerUnit ? employerUnit.label : "",
                            trainingPartner: trainingPartner ? trainingPartner.label : "",
                            partnerId: trainingPartner ? trainingPartner.value : "",
                            // employerId: employerUnit ? employerUnit.value : "",
                            programId: programId,
                            // batch: batch ? Number(batch) : 1,
                            addedFrom: "create-candidate",
                            userId: userDetails._id,
                            primaryOccupation: primaryOccupation ? primaryOccupation : "",
                            annualIncome: sanitizeAnnualIncome(annualIncome),
                            engagementType: engagementType ? engagementType.value : "",
                            passingYear: passingYear ? passingYear : "",
                            documents: {
                                aadhar: uploadedDocumentUrls.aadhar,
                                pan: uploadedDocumentUrls.pan,
                                qualification: uploadedDocumentUrls.qualification
                            }
                        }

                        let dataResponse = null;
                        if (candidateID === null) {
                            dataResponse = await createCandidateCall({}, requestData);
                        }
                        else {
                            dataResponse = await updateCandidateCall({}, requestData, candidateID);
                        }
                        if (dataResponse && dataResponse.statusCode === 200) {

                            if (candidateID === null) {
                                ShowToast('Please wait', TYPE_INFO, INTERVAL, "");
                                ShowToast('Candidate created Successfully', TYPE_SUCCESS, INTERVAL, props, "/candidate-page");
                            }
                            else {
                                ShowToast('Please wait', TYPE_INFO, INTERVAL, "");
                                ShowToast('Candidate updated Successfully', TYPE_SUCCESS, INTERVAL, props, "/candidate-page");
                            }
                        }
                        else {
                            ShowToast(`Error Occurred while ${candidateID ? "Updating" : "Creating"} candidate.`, TYPE_INFO, INTERVAL, "");
                        }
                    }
                    catch (error) {
                        console.log("Error Occured while creating/updating candidate", error);
                    }
                }
            }
            finally {
                setLoading(false);
            }
        }
    }

    const cancelHandler = () => {
        history.push("./candidate-page");
    }

    const isFormValid = () => {
        let isValid = true;
        let error = {};

        if (!engagementType) {
            isValid = false;
            error.engagementTypeError = "Please select engagement type";
        }

        if (!firstName) {
            isValid = false;
            error.firstNameError = "Please enter first name";
        }

        if (!lastName) {
            isValid = false;
            error.lastNameError = "Please enter last name";
        }

        if (!fatherName) {
            isValid = false;
            error.fatherNameError = "Please enter father name";
        }

        if (!dobDate) {
            isValid = false;
            error.dobDateError = "Please select date of birth";
        }

        if (ageNumber === "" || ageNumber === null || ageNumber === undefined) {
            isValid = false;
            error.ageNumberError = "Please select date of birth";
        }
        else if (Number(ageNumber) < MIN_CANDIDATE_AGE) {
            isValid = false;
            error.ageNumberError = MIN_CANDIDATE_AGE_ERROR;
        }

        if (!gender) {
            isValid = false;
            error.genderError = "Please select gender";
        }

        if (email) {
            if (!emailPattern.test(email)) {
                isValid = false;
                error.emailIdError = "Please enter a valid email address.";
            }
        } else {
            isValid = false;
            error.emailIdError = "Please enter an email address";
        }

        if (mobileNumber) {
            if (!PHONE_NUMBER_PATTERN.test(mobileNumber)) {
                isValid = false;
                error.MobileNoError = "Please enter a valid mobile number.";
            }
        } else {
            isValid = false;
            error.MobileNoError = "Please enter a mobile number";
        }

        if (!qualificationsName) {
            isValid = false;
            error.qualificationsError = "Please select qualification";
        }

        if (!passingYear) {
            isValid = false;
            error.passingYearError = "Please enter year of qualification";
        }

        if (!state) {
            isValid = false;
            error.stateError = "Please enter state";
        }

        if (!city) {
            isValid = false;
            error.cityError = "Please enter city";
        }
        
        if(!adharNo){
            isValid = false;
            error.aadharNumberError = "Please enter Aadhaar number";
        }

        if (!primaryOccupation) {
            isValid = false;
            error.primaryOccupationError = "Please enter primary occupation income";
        }

        if (!annualIncome) {
            isValid = false;
            error.annualIncomeError = "Please enter annual income";
        }

        if (!documentSectionData.aadharUpload) {
            isValid = false;
            error.aadharUploadError = "Please upload aadhar card";
        }

        if (!documentSectionData.qualificationUpload) {
            isValid = false;
            error.qualificationUploadError = "Please upload qualification certificate";
        }

        setError(error);
        return isValid;
    };

    const handleGenderChange = (selected) => {
        setGenderSelectedOption(selected);
        setGender(selected.value);
    };

    // const handleDepartmentChange = (event) =>{
    //     setDepartmentSelected(event);
    // }

    // const handleEmployerUnitChange = (event) => {
    //     setEmployerUnit(event)
    // }

    const handleStateChange = (event) => {
        setState(event);
        changeCityComponent(event);
        setCity(null);
    }

    const changeCityComponent = (event) => {
        let list = metaData[0].meta_data.cities.filter((item) => item.state_id === event.value);
        list  =  list.map((item) => {
            return ({label: item.city_name, value: item.city_id});
        })
        setCityComponent(list);
    }

    const handleCityChange  = (event) =>{ 
        setCity(event)
    }

    const handlePartnerChange = (event) => {
        setTrainingPartner(event);
    }

    const handleQualificationsChange = (event) => {
        setQualificationsName(event)
    };

    const handleDateChange = (date) => {
        setdobDate(date);
        const calculatedAge = calculateAgeFromDate(date);
        setAgeNumber(calculatedAge);
        setError((previousError) => ({
            ...previousError,
            dobDateError: "",
            ageNumberError: calculatedAge !== "" && Number(calculatedAge) < MIN_CANDIDATE_AGE ? MIN_CANDIDATE_AGE_ERROR : ""
        }));
    };

    const handleEngagementTypeChange = (event) => {
        setEngagementType(event);
    }

    const handleDocumentFileChange = (key, event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            setDocumentSectionData((prev) => ({ ...prev, [key]: reader.result }));
        };
        reader.readAsDataURL(file);
    };

    const getDocumentFileName = (value) => {
        if (typeof value !== "string" || !value) {
            return "";
        }
        return value.split("/").pop() || "document";
    };

    const isDownloadableDocument = (value) => typeof value === "string" && /^https?:\/\//i.test(value);

    const handleDocumentDownload = async (documentUrl, label) => {
        if (!documentUrl) {
            return;
        }

        if (documentUrl.startsWith("data:")) {
            window.open(documentUrl, "_blank", "noopener,noreferrer");
            return;
        }

        const s3KeyMatch = documentUrl.match(/^https:\/\/[^/]+\.s3\.amazonaws\.com\/(.+)$/i);
        const fileKey = s3KeyMatch ? s3KeyMatch[1] : documentUrl;

        try {
            const response = await downloadDocumentBucket({}, { fileKey });
            const downloadUrl = response?.data?.downloadUrl || documentUrl;
            window.open(downloadUrl, "_blank", "noopener,noreferrer");
        } catch (error) {
            console.error(`Failed to download ${label}:`, error);
            if (/^https?:\/\//i.test(documentUrl)) {
                window.open(documentUrl, "_blank", "noopener,noreferrer");
            }
        }
    };

    const uploadDocumentFileToS3 = async (fieldKey, fileValue) => {
        if (!fileValue) {
            return null;
        }

        let file = fileValue;

        if (typeof file === "string" && /^(https?:\/\/|http:\/\/)/i.test(file)) {
            return file;
        }

        if (typeof file === "string" && file.startsWith("data:")) {
            const mimeType = file.match(/data:(.*);base64/)[1];
            const extension = mimeType.split("/")[1];
            const blob = await fetch(file).then((res) => res.blob());
            file = new File([blob], `${fieldKey.replace(/\s+/g, "_")}.${extension}`, { type: mimeType });
        }

        const response = await getS3PresignedUrl({}, { fileName: file.name, fileType: file.type });
        const { url, fileUrl } = response.data;
        await uploadDocumentBucket({ "Content-Type": file.type }, { url, file });
        return fileUrl;
    };

    return (
        <>
            <div className="main-content">
                <div className="back">
                    <ul className="breadcrumb1">

                    </ul>
                </div>
                <div className="add-meter-main-view">
                    <div className="mx-auto text-left border create-meter-div create-candidate-outer-div">
                        <form className="pt-1">
                            <div className="meter-icon-wrapper">
                                <h4>{candidateID === null ? "Add New Candidate" : "Edit Candidate"}</h4>
                                <i className={`${USERS_ICON} list-table-icon`}></i>
                            </div>

                            <div className="row">
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Engagement type <span className="text-danger">*</span></label>
                                    <Select
                                        name="engagementType"
                                        placeholder={"Select Engagement Type"}
                                        value={engagementType}
                                        options={engagementTypeOptions}
                                        onChange={handleEngagementTypeChange}
                                    />
                                    <div className="text-danger error-msg">
                                        {error.engagementTypeError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Training Partner <span className="text-danger">*</span></label>
                                    <Select
                                        name="trainingPartner"
                                        placeholder={"Select Training Partner"}
                                        value={trainingPartner}
                                        options={partnerListComponent}
                                        onChange={handlePartnerChange}
                                        isDisabled={isPartnerLogin}
                                    />
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">First Name <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={firstName} onChange={(e) => { setFirstName(e.target.value) }} placeholder="Enter First Name" />
                                    <div className="text-danger error-msg">
                                        {error.firstNameError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={lastName} onChange={(e) => { setLastName(e.target.value) }} placeholder="Enter Last Name" />
                                    <div className="text-danger error-msg">
                                        {error.lastNameError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Father Name <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={fatherName} onChange={(e) => { setFatherName(e.target.value) }} placeholder="Enter Father Name" />
                                    <div className="text-danger error-msg">
                                        {error.fatherNameError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Gender <span className="text-danger">*</span></label>
                                    <Select
                                        name="gender"
                                        placeholder={"Select Gender"}
                                        value={selectedGenderOption}
                                        options={genderOptions}
                                        onChange={handleGenderChange}
                                    />
                                    <div className="text-danger error-msg">
                                        {error.genderError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">
                                        Date of Birth <span className="text-danger">* </span>
                                    </label>
                                    <DatePicker
                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                        selected={dobDate}
                                        onChange={handleDateChange}
                                        placeholderText="Select Date of Birth"
                                    />
                                    <div className="text-danger error-msg">{error.dobDateError}</div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Age <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={ageNumber} readOnly placeholder="Age auto-calculates from DOB" />
                                    <div className="text-danger error-msg">
                                        {error.ageNumberError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Highest Qualification <span className="text-danger">*</span></label>
                                    <Select
                                        name="qualification"
                                        placeholder={"Select Qualification"}
                                        value={qualificationsName}
                                        options={qualificationsListComponent}
                                        onChange={handleQualificationsChange}
                                    />
                                    <div className="text-danger error-msg">
                                        {error.qualificationsError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Year of Qualification <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={passingYear} onChange={(e) => { setPassingYear(e.target.value) }} placeholder="Enter Year of Qualification" />
                                    <div className="text-danger error-msg">
                                        {error.passingYearError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6 email-input">
                                    <label className="form-label">Email <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={email} onChange={(e) => { setEmail(e.target.value) }} placeholder="Enter Email" />
                                    <div className="text-danger error-msg">
                                        {error.emailIdError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Mobile <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={mobileNumber} onChange={mobileNumberHandler} placeholder="Enter Mobile Number" />
                                    <div className="text-danger error-msg">
                                        {error.MobileNoError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Aadhar Number <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={adharNo} onChange={adharChangeHandler} placeholder="Enter Aadhar No." />
                                    <div className="text-danger error-msg">
                                        {error.aadharNumberError}
                                    </div>
                                </div>
                                {/* <div className="input-label-group col-md-6">
                                    <label className="form-label">Select Department</label>
                                    <Select
                                        name="department"
                                        placeholder={"Select Department"}
                                        value={departmentSelected}
                                        options={departmentListComponent}
                                        onChange={handleDepartmentChange}
                                    />
                                </div> */}
                                {/* <div className="input-label-group col-md-6">
                                    <label className="form-label">Select Employer Unit</label>
                                    <Select
                                        name="employerUnit"
                                        placeholder={"Select Employer Unit"}
                                        value={employerUnit}
                                        options={employerListComponent}
                                        onChange={handleEmployerUnitChange}
                                    />
                                </div> */}
                                {/* <div className="input-label-group col-md-6">
                                    <label className="form-label">Training Batch</label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" type="number" value={batch ?? ""} onChange={(e) => { const nextValue = e.target.value; setBatch(nextValue === "" ? null : Number(nextValue)); }} placeholder="Enter Training Batch" />
                                </div> */}
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Select State <span className="text-danger">*</span></label>
                                    <Select
                                        name="state"
                                        placeholder={"Select State"}
                                        value={state}
                                        options={stateComponent}
                                        onChange={handleStateChange}
                                    />
                                    <div className="text-danger error-msg">
                                        {error.stateError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Select Candidate Home city <span className="text-danger">*</span></label>
                                    <Select
                                        name="city"
                                        placeholder={"Select City"}
                                        value={city}
                                        options={cityComponent}
                                        onChange={handleCityChange}
                                    />
                                    <div className="text-danger error-msg">
                                        {error.stateError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Primary occupation of the earning parent <span className="text-danger">*</span></label>
                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" type="text" value={primaryOccupation} onChange={(e) => { setPrimaryOccupation(e.target.value) }} placeholder="Enter Primary Occupation" />
                                    <div className="text-danger error-msg">
                                        {error.primaryOccupationError}
                                    </div>
                                </div>
                                <div className="input-label-group col-md-6">
                                    <label className="form-label">Annual household income <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                        type="text"
                                        inputMode="numeric"
                                        value={annualIncome || ""}
                                        onChange={handleAnnualIncomeChange}
                                        placeholder="Enter Annual Household Income"
                                    />
                                    <div className="text-danger error-msg">
                                        {error.annualIncomeError}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 document-box">
                                <h6 className="mb-3" style={{ fontWeight: 600, color: '#2f2f2f' }}>Documents</h6>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label" style={{ display: 'block', marginBottom: 8 }}>Aadhar Card <span className="text-danger">*</span></label>
                                        {isDownloadableDocument(documentSectionData.aadharUpload) && (
                                            <div className="mb-2">
                                                <button
                                                    type="button"
                                                    className="download-link-button"
                                                    onClick={() => handleDocumentDownload(documentSectionData.aadharUpload, "Aadhar Card")}
                                                >
                                                    View
                                                </button>
                                                <div className="text-muted small mt-1">{getDocumentFileName(documentSectionData.aadharUpload)}</div>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            accept=".pdf,.png,.jpg,.jpeg"
                                            className="form-control"
                                            onChange={(event) => handleDocumentFileChange("aadharUpload", event)}
                                        />
                                        <div className="text-danger error-msg">
                                            {error.aadharUploadError}
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label" style={{ display: 'block', marginBottom: 8 }}>PAN Card</label>
                                        {isDownloadableDocument(documentSectionData.panUpload) && (
                                            <div className="mb-2">
                                                <button
                                                    type="button"
                                                    className="download-link-button"
                                                    onClick={() => handleDocumentDownload(documentSectionData.panUpload, "PAN Card")}
                                                >
                                                    View
                                                </button>
                                                <div className="text-muted small mt-1">{getDocumentFileName(documentSectionData.panUpload)}</div>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            accept=".pdf,.png,.jpg,.jpeg"
                                            className="form-control"
                                            onChange={(event) => handleDocumentFileChange("panUpload", event)}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label" style={{ display: 'block', marginBottom: 8 }}>Qualification Certificate <span className="text-danger">*</span></label>
                                        {isDownloadableDocument(documentSectionData.qualificationUpload) && (
                                            <div className="mb-2">
                                                <button
                                                    type="button"
                                                    className="download-link-button"
                                                    onClick={() => handleDocumentDownload(documentSectionData.qualificationUpload, "Qualification Certificate")}
                                                >
                                                    View
                                                </button>
                                                <div className="text-muted small mt-1">{getDocumentFileName(documentSectionData.qualificationUpload)}</div>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            accept=".pdf,.png,.jpg,.jpeg"
                                            className="form-control"
                                            onChange={(event) => handleDocumentFileChange("qualificationUpload", event)}
                                        />
                                        <div className="text-danger error-msg">
                                            {error.qualificationUploadError}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4 mb-5">
                                <div className="form-button-div">
                                    {loading ? (
                                        <i className={`${LOADING_SPIN_SMALL}`}></i>
                                    ) : (
                                        <button className="brand-button" onClick={createCandidateHandler}>
                                            {candidateID ? "Update" : "Submit"}
                                        </button>
                                    )}
                                    <button className="cancel_button ml-5" onClick={cancelHandler}>Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateCandidate;